import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'
import { FlexChildGrow } from 'components/flex'
import Modal from 'modals/dialog'
import Caption, { CaptionSmall } from 'components/typography/caption'

export const LoadingContainer = styled.div`
    height: 240px;
`

export const ModalBody = styled(Modal.Body)`
    overflow: clip;
    overflow-clip-margin: 4px;
    display: grid;
    grid-template-rows: max-content 1fr;

    margin-block-end: calc(var(--__huma-component-modal-row-gap) * -1);

    &:has(> :only-child) {
        grid-template-rows: 1fr;
    }
`

export const ContentRow = styled(FlexChildGrow)`
    overflow-y: auto;

    * + & {
        padding-block-start: 24px;

        ${belowTablet`
            padding-block-start: 16px;
        `}
    }
`

export const Section = styled.div`
    &:not(:last-child) {
        margin-block-end: 24px;
    }
`

export const SectionHeading = styled(CaptionSmall)`
    margin-block-end: 8px;
    padding-inline: 32px;

    ${belowTablet`
        padding-inline: 24px;
    `}
`

export const Empty = styled(Caption)`
    padding-inline: 32px;

    ${belowTablet`
        padding-inline: 24px;
    `}
`